import { JSONPrettyStringify } from 'src/app/utils/json';
import { DataLoader } from '../data-loader';
import {
    OperationCancelledError,
} from 'src/app/utils/promise/cancellation-token';
import { IQueryContext } from 'src/app/services/query-context/models/IQueryContext';
import { SQL_NOT_AVAILABLE } from '../data-loader-result';

export async function standardRun(
    instance: DataLoader,
    queryContext: IQueryContext,
    process: () => Promise<void>
) {
    try {
        await process();
    } catch (e) {
        // OperationCancelledError and other not Errors are passed further
        if (!(e instanceof OperationCancelledError)) {
            if (e instanceof Error) {
                console.error(e.message);
                console.error(e);
                const message = e.message;
                instance.emitter.emit({
                    data: undefined,
                    queryContext: queryContext,
                    status: 'error',
                    statusMessage: JSONPrettyStringify(
                        e,
                        Object.getOwnPropertyNames(e)
                    ),
                    isLoading: false,
                    sqlAndJsProcessing: SQL_NOT_AVAILABLE,
                });
                return;
            }
        }
        throw e;
    }
}
